var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _g3, _g4, _path8, _g5, _path9, _path10, _g6, _g7, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySummary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 448,
    height: 261,
    viewBox: "0 0 448 261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "140.5%",
    height: "222.7%",
    x: "-20.3%",
    y: "-53.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.134506119 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__c",
    width: "140.5%",
    height: "222.7%",
    x: "-20.3%",
    y: "-53.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0886691434 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__e",
    width: "154.3%",
    height: "161.7%",
    x: "-27.2%",
    y: "-26.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.258823208 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M4.044 6.045l75 1.669c1.087.024 1.956.912 1.956 2v20.241c0 1.105-.895 2-2 2h-.044l-75-1.669c-1.087-.024-1.956-.912-1.956-2V8.046c0-1.105.895-2 2-2h.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__d",
    d: "M4.044 6.045l75 1.669c1.087.024 1.956.912 1.956 2v20.241c0 1.105-.895 2-2 2h-.044l-75-1.669c-1.087-.024-1.956-.912-1.956-2V8.046c0-1.105.895-2 2-2h.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__f",
    d: "M5.214 5.622L45.935.782c1.522-.181 2.908.887 3.121 2.404l4.902 34.917c.216 1.54-.857 2.964-2.397 3.18l-.06.007-40.72 4.841c-1.522.18-2.909-.888-3.122-2.405L2.758 8.81c-.217-1.54.857-2.964 2.397-3.18l.059-.008z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__g",
    x1: "19.337%",
    x2: "92.745%",
    y1: "8.537%",
    y2: "128.117%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M264.245 61.907c18.342 2.684 43.677-9.336 42.795-21.949-.882-12.613-18.711-22.213-40.317-22.469-29.726-.352-31.04 18.81-30.608 24.994.882 12.613 9.789 16.74 28.13 19.424z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    fillRule: "nonzero",
    d: "M191.266 228.966c21.059-.069 54.21 1.106 76.85-5.98 42.563-13.323 69.903-45.98 64.113-101.618-8.87-85.232-85.774-22.318-103.602-39.72-16.818-16.416-22.525-54.035-47.51-55.972C114.906 20.542 73 43.979 73 119.267c0 75.289 57.616 109.896 118.266 109.699z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M256.957 210.292L271.574 94.183 200.636 89.904 184.265 88.292 167.574 205.509z",
    transform: "rotate(-4 219.574 149.292)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M121.427 115.718L230.369 56.279 288.164 152.587 178.988 216.343z",
    transform: "rotate(-66 204.796 136.311)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M121.008 118.124L227.838 54.987 284.407 148.815 177.038 212.074z",
    transform: "rotate(-65 202.708 133.53)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M115.26 85.548l73.498-8.75c1.621-.194 3.099.944 3.326 2.56l2.409 17.141c.23 1.64-.913 3.158-2.554 3.388l-.062.009-73.498 8.75c-1.62.194-3.098-.944-3.325-2.56l-2.41-17.141c-.23-1.641.913-3.158 2.554-3.389l.063-.008z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M13.981 75.737l4.58-23.57 44.17-42.81c.675-.655.692-1.733.037-2.409-.656-.675-1.734-.693-2.409-.038L15.805 50.092c-.25.242-.42.556-.487.898l-4.681 24.097c-.18.923.423 1.818 1.347 1.998.924.179 1.818-.424 1.998-1.348",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M78.115 15.724L53.289 17.58c-.34.025-.67.154-.936.367L3.771 56.68c-.737.587-.857 1.659-.27 2.395.586.736 1.658.856 2.394.27l48.172-38.407 24.302-1.817c.938-.07 1.642-.887 1.572-1.825-.07-.939-.887-1.642-1.826-1.572",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F5",
    d: "M15.808 66.333l.895-4.606c2.788-.798 5.576-2.294 8.047-4.467 4.588-4.036 6.948-9.409 6.701-14.14l.423.41v-.008c.372.58.674 1.2.908 1.851.398 1.11.597 2.32.597 3.587.009 4.141-2.166 8.912-6.305 12.547-3.454 3.041-7.561 4.66-11.266 4.826m-3.416-.282c-.213-.048-.423-.1-.63-.16l.68-3.492c.22-.006.442-.016.666-.032l-.716 3.684M8.59 64.354c-.474-.351-.915-.75-1.318-1.194-.638-.705-1.144-1.485-1.524-2.329 1.005.579 2.111.996 3.283 1.255l-.44 2.268",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4D0",
    d: "M15.179 66.347h-.015c-.962 0-1.892-.1-2.772-.296l.716-3.684c1.181-.08 2.388-.295 3.595-.64l-.895 4.606c-.21.01-.42.014-.63.014",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F0",
    d: "M31.913 41.51L31.913 41.51 32.061 41.376 31.913 41.51",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F5",
    d: "M50.374 35.392h-.014c-1.59 0-3.09-.271-4.426-.804-.967-.386-1.848-.906-2.625-1.567l-.911-1.148c1.51.53 3.139.788 4.815.788.146 0 .293-.002.441-.005v.544c3.205-.09 6.65-.735 9.788-3.059v-.499c.223-.135.445-.276.665-.42.914-.586 1.8-1.257 2.64-2.003 2.41-2.122 4.249-4.597 5.456-7.188l2.235-.167c-.536 3.658-2.637 7.586-6.168 10.688-3.652 3.215-8.032 4.84-11.896 4.84m17.06-18.87c.16-.669.278-1.337.352-2.003l.22-.017c.216.62.37 1.27.463 1.943l-1.034.077",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4D0",
    d: "M66.203 20.031c.538-1.153.95-2.33 1.232-3.51l1.034-.076c.07.508.106 1.029.106 1.56 0 .608-.045 1.23-.137 1.86l-2.235.166",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M31.882 41.538l-.902.817c.808.893 1.403 1.907 1.802 3.018.398 1.11.597 2.32.597 3.587.009 4.141-2.166 8.912-6.305 12.547-3.655 3.219-8.042 4.844-11.91 4.84-1.59 0-3.09-.271-4.425-.804-1.336-.533-2.508-1.324-3.467-2.383-.809-.893-1.404-1.907-1.803-3.018-.398-1.11-.599-2.32-.599-3.587-.007-4.142 2.166-8.912 6.307-12.546 3.656-3.22 8.042-4.846 11.908-4.842 1.59 0 3.09.272 4.425.804 1.336.534 2.508 1.324 3.47 2.384l.902-.817.902-.817c-1.222-1.349-2.72-2.352-4.372-3.01-1.654-.66-3.46-.978-5.327-.978-4.538.004-9.44 1.867-13.515 5.448-4.601 4.052-7.125 9.396-7.133 14.374 0 1.523.24 3.013.74 4.409.5 1.395 1.263 2.696 2.29 3.83 1.22 1.348 2.718 2.351 4.37 3.01 1.654.659 3.46.977 5.327.978 4.539-.005 9.442-1.867 13.518-5.448 4.599-4.053 7.123-9.396 7.131-14.374 0-1.523-.24-3.012-.74-4.408-.5-1.396-1.262-2.697-2.29-3.83l-.9.816M67.077 10.584l-.902.817c.808.892 1.403 1.906 1.802 3.017.398 1.111.598 2.32.598 3.587.008 4.141-2.167 8.912-6.305 12.547-3.656 3.22-8.043 4.845-11.91 4.84-1.59 0-3.09-.271-4.426-.804-1.336-.533-2.507-1.323-3.467-2.383-.809-.892-1.404-1.907-1.803-3.018-.4-1.11-.599-2.319-.599-3.587-.008-4.141 2.166-8.912 6.307-12.546 3.656-3.22 8.042-4.846 11.909-4.841 1.59 0 3.09.27 4.424.804 1.336.533 2.509 1.323 3.47 2.384l.902-.817.902-.818c-1.222-1.348-2.72-2.352-4.372-3.01-1.654-.66-3.46-.977-5.326-.978-4.539.005-9.44 1.867-13.516 5.449-4.601 4.052-7.126 9.395-7.134 14.373 0 1.524.24 3.013.741 4.41.5 1.395 1.263 2.696 2.29 3.83 1.22 1.347 2.718 2.35 4.37 3.01 1.654.659 3.46.976 5.328.977 4.538-.004 9.441-1.867 13.517-5.447 4.599-4.054 7.123-9.396 7.132-14.375 0-1.523-.24-3.012-.74-4.408-.5-1.396-1.263-2.697-2.29-3.83l-.902.817",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9CECC",
    d: "M43.52 33.287c-7.75-1.282-11.858 1.856-11.646 10.243l-6.765-6.554c4.994-2.187 9.798-6.412 12.568-11.054l5.843 7.365",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4C4C",
    d: "M10.853 70.576l4.58-23.572L59.6 4.197c.676-.655.693-1.734.038-2.41-.655-.675-1.733-.692-2.409-.037L12.676 44.931c-.25.243-.42.557-.486.899L7.507 69.926c-.18.924.424 1.818 1.348 1.998.924.18 1.818-.424 1.998-1.347",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4C4C",
    d: "M74.986 10.563L50.16 12.42c-.34.025-.668.154-.934.366L.642 51.52c-.736.586-.857 1.659-.27 2.395.586.735 1.658.856 2.394.27l48.171-38.406L75.24 13.96c.938-.07 1.642-.887 1.572-1.826-.07-.938-.888-1.642-1.825-1.572",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F5",
    d: "M26.425 36.35l1.132-1.096c.115.091.228.185.338.282-.485.29-.976.561-1.47.815",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F0EB",
    d: "M12.442 62.399l1.901-9.79.782-.623-2.017 10.381c-.224.016-.446.026-.666.032m4.261-.672l1.858-9.56 11.111-10.77 1.78 1.723c.246 4.731-2.114 10.104-6.702 14.14-2.47 2.173-5.259 3.67-8.047 4.467m-1.358-14.275l.087-.448 8.08-7.83c.671.02 1.324.09 1.954.21l-10.12 8.068",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8D2",
    d: "M13.108 62.367l2.017-10.38L29.1 40.842l.571.554-11.111 10.77-1.858 9.56c-1.207.345-2.414.56-3.595.64",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8D2",
    d: "M14.343 52.61l1.002-5.158 10.121-8.069c.715.134 1.399.33 2.044.588.493.197.963.429 1.409.696l.182.176L14.343 52.61",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4D0",
    d: "M28.919 40.667c-.446-.267-.916-.5-1.409-.696-.645-.258-1.33-.454-2.044-.588-.63-.119-1.283-.189-1.954-.21l1.933-1.872 3.474 3.366M31.451 43.12l-2.35-2.277-.182-.176-3.474-3.366.98-.95c.494-.254.985-.525 1.47-.815.3.262.588.542.859.842 1.685 1.86 2.565 4.21 2.697 6.742",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F5",
    d: "M2.5 57.897c-.766-1.075-1.304-2.275-1.623-3.554.255.14.54.213.828.213.312 0 .625-.085.904-.26-.113.758-.171 1.513-.172 2.259 0 .45.02.898.063 1.342",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F0EB",
    d: "M9.03 62.086c-1.17-.259-2.277-.676-3.282-1.255-.102-.225-.195-.455-.28-.689-.057-.162-.111-.327-.161-.492.208-.06.408-.162.588-.305l4.341-3.46-1.205 6.201m-4.137-6.301c.08-1.29.362-2.63.843-3.969l6.259-4.99-.758 3.9-6.344 5.059",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8D2",
    d: "M5.307 59.65c-.29-.973-.437-2.012-.437-3.095 0-.254.008-.511.024-.77l6.344-5.058-1.002 5.157-4.34 3.46c-.18.144-.38.245-.59.306",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4D0",
    d: "M5.748 60.831c-.93-.533-1.773-1.204-2.507-2.014-.267-.295-.514-.602-.74-.92-.043-.444-.064-.891-.064-1.342 0-.746.059-1.501.172-2.258.054-.034.106-.072.157-.112l2.97-2.369c-.48 1.338-.763 2.678-.842 3.969-.016.259-.024.516-.024.77 0 1.083.146 2.122.437 3.095.05.165.104.33.162.492.084.234.177.464.279.69",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F5",
    d: "M.528 51.62c-.08-4.618 2.274-9.778 6.717-13.685 3.866-3.4 8.51-5.145 12.713-5.145 1.248 0 2.456.154 3.595.464l-5.168 4.12c-3.07.826-6.123 2.442-8.815 4.807-2.089 1.839-3.748 3.944-4.94 6.16L.642 51.52c-.04.032-.078.065-.114.1",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4D0",
    d: "M4.63 48.34c1.192-2.215 2.851-4.32 4.94-6.16 2.692-2.364 5.744-3.98 8.815-4.806L4.63 48.341",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M12.037 62.404c-1.035 0-2.043-.105-3.006-.318l2.965-15.26 15.02-11.975c.184.128.365.262.54.403l-12.124 11.75-2.99 15.395c-.136.004-.271.005-.405.005",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4C4C",
    d: "M1.705 54.556c-.287 0-.573-.072-.828-.213-.218-.875-.333-1.789-.35-2.723.037-.035.075-.068.115-.1l22.911-18.266c1.255.341 2.424.872 3.464 1.597L2.767 54.185c-.052.04-.104.078-.158.112-.279.174-.592.26-.904.26",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F0EB",
    d: "M47.213 30.227c-1.42 0-2.767-.217-3.989-.644l4.43-3.532v4.17h-.034c-.135.004-.271.006-.407.006m-7.11-3.684c-.025-.31-.038-.625-.038-.943 0-.394.018-.794.057-1.198l7.532-6.006v.828l-7.551 7.319",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8D2",
    d: "M40.241 27.603c-.063-.347-.109-.7-.138-1.06l7.551-7.319v2.47l-7.413 5.91",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8D2",
    d: "M43.224 29.583c-.144-.05-.286-.103-.426-.16-.91-.363-1.741-.845-2.483-1.45-.027-.123-.051-.246-.074-.37l7.413-5.91v4.358l-4.43 3.532",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4D0",
    d: "M40.315 27.972c-.346-.282-.673-.592-.978-.93-.358-.395-.675-.815-.951-1.256l1.736-1.384c-.039.404-.057.804-.057 1.198 0 .318.013.632.038.943.03.36.075.713.138 1.06.023.124.047.247.074.37",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F0EB",
    d: "M57.442 26.737v-6.05l5.914-.443c-1.034 1.831-2.445 3.593-4.216 5.148l-.002.003c-.55.487-1.117.936-1.696 1.342m0-9.468v-1.977l7.87-.589c-.098.664-.247 1.337-.446 2.011l-7.424.555",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8D2",
    d: "M57.442 20.686V17.27l7.424-.555c-.35 1.181-.854 2.37-1.51 3.53l-5.914.442",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F5",
    d: "M36.974 21.382c-.026-.31-.038-.624-.038-.942-.008-4.14 2.166-8.911 6.309-12.546l-.002.001c1.394-1.221 2.887-2.218 4.411-2.974v4.134c-.997.634-1.964 1.359-2.89 2.172-2.777 2.446-4.798 5.363-5.965 8.387l-1.825 1.768",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4D0",
    d: "M38.799 19.614c1.167-3.024 3.188-5.94 5.966-8.387.925-.813 1.892-1.538 2.889-2.172v1.976l-8.855 8.583",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F5",
    d: "M63.423 6.684c-1.603-.61-3.345-.905-5.142-.906-.105 0-.21.002-.315.004l1.635-1.585c.078-.076.148-.157.208-.243 1.241.53 2.336 1.291 3.24 2.289.13.143.255.291.374.441",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F0EB",
    d: "M60.357 11.657l2.373-2.3c.078-.076.148-.157.209-.244.822.352 1.579.804 2.26 1.36.058.266.106.537.144.811l-4.986.373m-2.915-1.92v-1.5c.277-.017.552-.024.824-.024h.015c.24 0 .479.006.715.018l-1.554 1.506",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8D2",
    d: "M57.442 11.875V9.737l1.554-1.506c1.325.07 2.577.333 3.71.786.078.031.156.063.233.096-.06.087-.13.168-.209.244l-2.373 2.3-2.915.218",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D4D0",
    d: "M65.199 10.473c-.681-.556-1.438-1.008-2.26-1.36-.077-.033-.155-.065-.234-.096-1.132-.453-2.384-.716-3.709-.786-.236-.012-.475-.019-.715-.018h-.015c-.272 0-.547.007-.824.024V6.29l.524-.508c.105-.002.21-.004.315-.004 1.797 0 3.54.295 5.142.906.62.781 1.093 1.644 1.427 2.575.141.393.257.798.349 1.214",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M37.112 22.443c-.063-.347-.109-.7-.138-1.06l10.68-10.352v3.008l-10.542 8.404M57.442 6.29V3.254c.835.151 1.627.384 2.367.7-.06.086-.13.167-.208.243L57.442 6.29",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4C4C",
    d: "M38.386 25.786c-.347-.554-.63-1.143-.852-1.76-.182-.508-.323-1.037-.422-1.583l10.542-8.404v4.357l-9.268 7.39m19.056-10.494v-3.417l2.915-.218 4.986-.373c.07.508.105 1.03.105 1.56.001.609-.044 1.23-.137 1.86l-7.869.588",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7E80",
    strokeWidth: 2.434,
    d: "M28.754 36.378c4.833 5.337 3.04 14.686-4.004 20.882-7.045 6.196-16.675 6.893-21.51 1.557C-1.592 53.48.2 44.13 7.246 37.935c7.045-6.197 16.675-6.894 21.509-1.557z",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7E80",
    d: "M59.944 26.306l-.806-.911c-.757.669-1.545 1.267-2.35 1.781l-.016.01c-2.96 1.952-6.196 2.964-9.148 3.036h-.004c-.135.003-.271.005-.407.005-1.587 0-3.084-.271-4.415-.803-1.333-.533-2.502-1.322-3.46-2.381-.81-.893-1.405-1.907-1.804-3.017-.398-1.11-.598-2.319-.598-3.586-.008-4.14 2.166-8.911 6.309-12.546l-.002.001c1.548-1.357 3.22-2.436 4.919-3.217l.003-.001c2.34-1.084 4.748-1.626 6.98-1.625.72 0 1.422.055 2.099.168h.002c2.317.38 4.318 1.384 5.803 3.023.808.892 1.403 1.906 1.801 3.016.398 1.11.598 2.318.598 3.586.008 4.14-2.167 8.911-6.308 12.547l-.002.003.806.91.804.914c4.601-4.053 7.126-9.396 7.134-14.374 0-1.523-.24-3.012-.74-4.407s-1.262-2.696-2.29-3.829c-1.89-2.093-4.44-3.34-7.214-3.791h.002c-.815-.134-1.649-.2-2.494-.2-2.624 0-5.368.63-8.004 1.85l.004-.002c-1.923.884-3.787 2.092-5.507 3.598l-.001.002c-4.604 4.053-7.128 9.396-7.136 14.374 0 1.523.24 3.012.74 4.408.501 1.395 1.263 2.695 2.291 3.829 1.217 1.346 2.712 2.35 4.362 3.007 1.65.659 3.454.977 5.318.977.157 0 .315-.002.474-.006h-.004c3.46-.087 7.112-1.253 10.428-3.437l-.669-1.016.654 1.026c.92-.587 1.809-1.262 2.655-2.011l-.003.002-.804-.913",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7E80",
    d: "M40.391 28.127c-7.75-1.283-11.858 1.856-11.645 10.243l-6.765-6.555c4.993-2.186 9.797-6.411 12.567-11.053l5.843 7.365",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFDFC",
    d: "M47.654 33.2v-.544l.033-.001h-.004c3.229-.081 6.625-1.102 9.76-3.013v.499c-3.14 2.324-6.584 2.97-9.789 3.06",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M47.654 2.24v-.288C50.142.658 52.719 0 55.147 0c.783 0 1.55.068 2.295.206v.58c-.752-.113-1.52-.168-2.296-.168-2.455 0-5.014.551-7.492 1.621",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAF7",
    d: "M47.654 30.22v-4.169l6.413-5.113 3.375-.252v6.051c-.217.152-.435.299-.655.44l-.015.009c-2.95 1.945-6.175 2.957-9.118 3.035m0-10.997v-.828l3.283-2.617.295-.023-3.578 3.468m6.672-1.721l2.21-2.143.906-.068v1.977l-3.116.234",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0ED",
    d: "M47.654 21.693v-2.469l3.578-3.468 5.305-.396-2.21 2.143-1.038.077c-.34.025-.67.154-.936.367l-4.699 3.746",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0ED",
    d: "M47.654 26.051v-4.358l4.7-3.746c.265-.213.594-.342.935-.367l1.037-.077 3.116-.234v3.417l-3.375.252-6.413 5.113",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAF7",
    d: "M51.197 12.342l3.907-3.786c.79-.168 1.572-.275 2.338-.32v1.501l-2.39 2.317-3.855.288",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0ED",
    d: "M55.052 12.054L57.442 9.737 57.442 11.875 55.052 12.054",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEFEC",
    d: "M55.104 8.556l2.338-2.266v1.947c-.766.044-1.548.15-2.338.319",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFDFC",
    d: "M47.654 9.055V4.92c.169-.084.338-.165.508-.243l.003-.001c2.338-1.083 4.745-1.625 6.976-1.625h.005c.242 0 .483.006.721.02l-4.026 3.9c-1.425.525-2.832 1.22-4.187 2.083",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEFEC",
    d: "M47.654 11.031V9.055c1.355-.862 2.762-1.558 4.187-2.082l-4.187 4.058",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7E80",
    d: "M47.654 14.039V11.03l8.213-7.96c.469.025.928.074 1.377.149h.002c.065.01.131.022.196.034V6.29l-6.245 6.052-1.038.078c-.34.025-.668.154-.934.366l-1.571 1.253",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7E80",
    d: "M47.654 18.396V14.04l1.57-1.253c.267-.212.596-.341.935-.366l1.038-.078 3.855-.288 2.39-.179v3.417l-.905.068-5.305.396-.295.023-3.283 2.617",
    transform: "rotate(21 107.858 796.581)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M47.654 32.656V30.22c2.943-.078 6.168-1.09 9.118-3.035l.015-.01c.22-.14.438-.287.655-.439v2.905c-3.134 1.91-6.53 2.932-9.759 3.013h.004-.033m0-27.734V2.24C50.132 1.17 52.691.62 55.146.618c.777 0 1.544.055 2.296.169v2.467c-.065-.012-.13-.024-.196-.034h-.002c-.45-.075-.908-.124-1.377-.149-.238-.013-.479-.02-.721-.02h-.005c-2.231 0-4.638.543-6.976 1.626l-.003.001c-.17.078-.34.16-.508.243",
    transform: "rotate(21 107.858 796.581)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#EDEDED"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L29.83.135 29.83 3.135 0 3zM0 6L30.088 6.462 30.088 15 0 14.538z",
    transform: "rotate(-6 1237.658 -1392.799)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M157 124.184L247.185 114 254 178.888 163.489 188z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CDCCCC",
    fillRule: "nonzero",
    d: "M92.755 61.97L77.613 64.844 79.105 76.004 85.465 79.504 94.651 75.575z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M34.171 65.379L41.252 66.487 41.086 67.547 34.132 66.458 22.625 70.22 22.29 69.201 33.921 65.399zM42.919 14.064L60.648 31.063 70.771 23.471 71.65 23.709 79.636 75.847 85.502 79.696 83.816 80.469 78.217 76.756 70.359 25.667 60.39 32.584 60.171 32.53 42.333 15.486z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M45.601 9.244L47.215 9.434 43.689 15.307 42.375 14.506zM97.511 60.777L97.67 61.838 77 64.925 76.841 63.864z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M11.77 29.507l4.657 7.867c4.1 6.79 6.125 14.628 5.827 22.551l-1.098 28.451",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M61.812 25l.946 1.213-6.275 4.879-1.053.84-.868.681c-.493.382-.862.657-1.103.814-1.853 1.05-3.867 1.784-5.96 2.174l-.573.098-5.518.844.33 3.425c.052.524.096.932.127 1.198l.034.263.113.752-10.379 1.67-10.122 3.554-.511-1.45 10.186-3.576.133-.034 8.967-1.445-.207-2.053-.335-3.604 6.947-1.063c2.113-.329 4.148-1.037 5.963-2.063l.164-.114c.13-.094.305-.224.514-.385l1.14-.89 1.203-.96L61.812 25z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.362,
    d: "M31.5 43.5L20.224 25.491M61.015 50.986L61.923 62.392 55.307 63.262",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M34.782 27.583L35.137 28.595 24.056 32.469 23.701 31.456z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M33.681 24.558L35.137 28.595 34.112 28.96 32.649 24.925zM85.348 0L82.289 14.712 85.465 35.467 72.977 37.371 72.745 35.851 83.709 34.18 80.723 14.668 83.339.86z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M3.399 58.447L10.803 58.519 13.394 70.64 22.207 70.033",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.362,
    d: "M11.34 63.024L22.027 62.535",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M15.555 36.063L2.707 40.58 0.617 40.282",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M93.595 61.97L95.766 75.145 94.782 75.575 92.535 62.147z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.952,
    d: "M77.399 67L69.733 69.777 68.315 60.777",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M22.354 61.158L32.458 56.981 48.274 57.638 48.495 82.863 46.955 82.876 46.745 59.112 32.731 58.531 22.943 62.578z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M39.879 66.517L40.954 66.516 40.967 77.14 33.629 77.773 33.443 83.162 32.369 83.125 32.588 76.786 39.891 76.156zM94.465 40.994L94.651 42.05 74.243 45.614 74.058 44.557zM98.802 69.06l.133 1.064-.647.083c-.485.064-.97.132-1.423.2l-.781.122-.545.098c-.157.03-.286.058-.385.082l-.155.044-.356-1.012c.2-.07.548-.146 1.043-.232l.22-.038c.242-.04.51-.082.8-.125l.951-.136 1.145-.15z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M73.805 44.996l.858 1.276-7.737 5.181-24.78.339-.767 12.359c-.116 1.723-.178 2.394-.237 2.625l-.021.065-1.408-.625.596-9.565.384-6.377 25.756-.353 7.356-4.925z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    d: "M47.307 58.972L41.265 58.983 40.978 67.494 41.074 72.75 41.193 77.136 33.718 77.744 33.551 82.726 36.237 81.499 46.841 82.726z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M65.356 9L79 14.949 78.582 16 64 9.599zM43.585 25L54 50.684 52.824 51 42.409 25.316z",
    transform: "translate(153 108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M91.835 13L92 14.154 77.192 16 77 15.013z",
    transform: "translate(153 108)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M5.364 15.512L79.85 6.623c1.621-.193 3.1.945 3.327 2.561l2.409 17.14c.23 1.642-.913 3.159-2.554 3.39l-.062.007L8.484 38.61c-1.621.193-3.1-.945-3.327-2.561l-2.409-17.14c-.23-1.642.913-3.159 2.554-3.39l.062-.007z",
    transform: "translate(135 105)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135 105) rotate(-8 41.5 19)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2A90D5",
    d: "M16.898 13.7c.548-.068 1.047.322 1.115.87l3.97-.487L23.81 28.97 7.93 30.92 6.101 16.033l3.97-.488c-.067-.548.323-1.047.87-1.114.549-.068 1.048.322 1.115.87l3.97-.487c-.067-.548.323-1.047.871-1.114zm3.709 5.59l-11.91 1.462.974 7.94 11.911-1.462-.975-7.94zm-8.811 2.089l.244 1.985-1.985.243-.244-1.985 1.985-.243zm3.97-.488l.244 1.985-1.985.244-.244-1.985 1.985-.244zm3.97-.487l.244 1.985-1.985.243-.244-1.985 1.985-.243z",
    opacity: 0.216,
    transform: "translate(135 105)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M113.606 82.384l74.502-8.786c1.08-.127 2.064.632 2.215 1.708l2.817 20.045c.154 1.094-.608 2.105-1.702 2.259l-.044.006-74.502 8.786c-1.08.127-2.064-.632-2.215-1.708l-2.817-20.045c-.154-1.094.608-2.105 1.702-2.259l.044-.006zM117.826 52.53l62.581-7.384c1.08-.127 2.064.632 2.215 1.708l2.298 16.352c.154 1.093-.608 2.105-1.702 2.259l-.044.005-62.581 7.384c-1.08.127-2.064-.632-2.215-1.708l-2.298-16.352c-.154-1.093.608-2.105 1.702-2.259l.044-.005z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131 55) rotate(-8 41.5 19)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__c)",
    xlinkHref: "#prefix__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M8.933 15.674L72.94 7.622c.548-.069 1.048.32 1.117.867l.004.038.044.51c.047.535-.338 1.011-.871 1.078L9.227 18.168c-.548.069-1.049-.32-1.117-.868l-.005-.038-.044-.509c-.046-.535.338-1.012.872-1.079zM14.512 65.844l64.008-8.052c.548-.069 1.048.32 1.117.867l.004.038.044.51c.047.535-.338 1.011-.871 1.078l-64.008 8.053c-.548.068-1.048-.32-1.117-.868l-.004-.038-.044-.509c-.047-.535.338-1.012.871-1.079z",
    transform: "translate(131 55)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M9.268 21.549l50.264-6.093c.548-.067 1.047.324 1.113.872l.003.022.05.508c.054.54-.335 1.026-.875 1.091L9.56 24.042c-.548.067-1.046-.324-1.113-.872l-.002-.022-.05-.508c-.054-.54.334-1.026.874-1.091z",
    transform: "translate(131 55)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M22.848 70.719l50.264-6.093c.548-.067 1.047.324 1.113.872l.003.022.05.508c.054.54-.335 1.026-.875 1.091L23.14 73.212c-.548.067-1.046-.324-1.113-.872l-.002-.022-.05-.508c-.054-.541.334-1.026.874-1.091z",
    opacity: 0.805,
    transform: "translate(131 55)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M10.48 27.397l50.263-6.093c.549-.067 1.047.324 1.113.872l.003.022.05.508c.054.54-.335 1.026-.875 1.091L10.77 29.89c-.548.067-1.046-.324-1.113-.872l-.002-.022-.05-.508c-.054-.54.335-1.026.874-1.091z",
    transform: "translate(131 55)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M24.06 76.567l50.263-6.093c.548-.067 1.047.324 1.113.872l.003.022.05.508c.054.54-.335 1.026-.875 1.091L24.35 79.06c-.548.067-1.046-.324-1.113-.872l-.002-.022-.05-.508c-.054-.54.334-1.026.874-1.091z",
    opacity: 0.805,
    transform: "translate(131 55)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M163.49 187.406L254.32 179 256 187.406 205.4 195 162 195z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF1B12",
    strokeDasharray: "1 3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M175 177l11.422-3.677 6.505 2.418.82-11.87v-4.93h24.727l8.526-5.366L223.852 138"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(133 109)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M4.55 7.134l44.557-6.105c2.308-.316 4.437 1.296 4.757 3.604l4.912 35.38c.32 2.311-1.292 4.444-3.603 4.765l-.007.001-44.557 6.105C8.3 51.2 6.172 49.588 5.852 47.28L.94 11.9C.619 9.588 2.232 7.454 4.542 7.134l.008-.001z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__e)",
    xlinkHref: "#prefix__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M24.007 22.527l27.096-3.313c.548-.067 1.047.323 1.114.872v.01l.175 1.567c.061.545-.328 1.037-.872 1.104l-27.096 3.312c-.548.067-1.047-.323-1.114-.871l-.001-.01-.175-1.568c-.06-.545.329-1.037.873-1.103zM23.007 11.527L49.19 8.333c.548-.067 1.046.323 1.113.872l.001.01.175 1.567c.06.545-.328 1.037-.873 1.103L23.424 15.08c-.548.067-1.047-.323-1.114-.871l-.001-.01-.175-1.568c-.06-.545.329-1.037.873-1.103zM26.003 33.524l26.34-3.306c.549-.069 1.049.32 1.117.868l.002.013.175 1.567c.06.544-.327 1.035-.87 1.103l-26.34 3.306c-.548.069-1.048-.32-1.117-.867l-.001-.014-.175-1.567c-.06-.544.327-1.035.87-1.103z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 9.969,
    y: 10.215,
    fill: "#FFDC7A",
    rx: 1,
    transform: "rotate(-7 13.969 14.215)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64BABA",
    d: "M12.31 21.688l5.956-.73c.548-.068 1.047.322 1.114.87l.732 5.955c.067.548-.323 1.047-.871 1.115l-5.955.73c-.548.068-1.047-.322-1.115-.87l-.73-5.955c-.068-.548.322-1.047.87-1.115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M13.993 32.986l5.955-.732c.548-.067 1.047.323 1.115.871l.73 5.955c.068.549-.322 1.048-.87 1.115l-5.955.731c-.548.067-1.047-.322-1.115-.87l-.73-5.956c-.068-.548.322-1.047.87-1.114z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "rotate(14 -224.702 424.84)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    d: "M93.012 16.961c-22.64-13-51.532-5.813-65.4 16.267-13.868 22.08-7.745 51.147 13.86 65.793l-3.21-1.843c-1.799-.983-4.056-.351-5.08 1.422-1.022 1.774-.436 4.038 1.32 5.096l.31.18L4.576 156.32c-1.976 3.43-.79 7.809 2.649 9.78 3.439 1.97 7.829.788 9.805-2.642l30.236-52.446.31.18c1.775.834 3.894.172 4.875-1.523.98-1.694.494-3.856-1.118-4.97l-3.476-1.998c23.593 11.42 52.015 2.099 64.21-21.058 12.195-23.157 3.76-51.788-19.055-64.683zm9.154 61.141c-10.594 18.382-34.122 24.717-52.55 14.15-18.43-10.566-24.781-34.033-14.188-52.415 10.594-18.381 34.122-24.717 52.55-14.15 8.852 5.073 15.32 13.446 17.98 23.276s1.296 20.313-3.792 29.14z",
    opacity: 0.161
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7E6FD",
    d: "M3.596 157.956c-3.429-1.97-4.612-6.339-2.645-9.765l31.866-55.345 12.432 7.134-31.866 55.335c-.946 1.647-2.509 2.851-4.345 3.347-1.836.495-3.794.241-5.442-.706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CD5FF",
    d: "M43.473 98.741l1.776 1.24-31.866 55.334c-.946 1.647-2.509 2.851-4.345 3.347-1.085.293-3.296.104-3.296.104s4.046-1.063 5.77-4.144c3.048-5.449 13.702-24.076 31.961-55.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#195780",
    d: "M88.344 11.701C67.187-.532 40.186 5.505 26.253 25.583S16.113 73.07 34.974 88.61c-1.771-.476-3.62.44-4.314 2.137-.695 1.698-.018 3.647 1.579 4.55l12.636 7.262c1.623.925 3.683.473 4.77-1.045 1.087-1.52.85-3.614-.548-4.853 22.92 8.259 48.35-2.381 58.56-24.502 10.21-22.12 1.81-48.375-19.342-60.462l.029.005zm9.6 59.976C87.407 90.005 64.007 96.322 45.678 85.786 27.348 75.251 21.03 51.852 31.567 33.524 42.102 15.196 65.502 8.878 83.832 19.413c18.329 10.537 24.647 33.935 14.112 52.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A90D5",
    fillOpacity: 0.521,
    d: "M41.83 15.923l-1.106-1.688c8.038-5.294 17.557-7.848 27.15-7.285l-.121 2.022c-9.159-.538-18.247 1.9-25.923 6.951z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#195780",
    d: "M15.288 152.575L16.29 150.785 3.717 143.525 2.715 145.314zM17.093 148.955L18.1 147.165 5.526 139.905 4.525 141.694z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.273,
    cy: 53.748,
    r: 39.412,
    fill: "#FFF",
    opacity: 0.3,
    transform: "rotate(-60.68 66.273 53.748)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M30.46 73.848L2.797 69.179 10.816 21.667 16.311 22.595 17.456 15.816 19.665 16.188 21.988 2.422 69.499 10.441 68.455 16.627 74.014 18.039 68.085 42.436 74.753 47.948 63.394 61.689 61.931 67.694 59.017 66.984 58.538 67.563 57.162 75.713 52.457 74.919 44.053 85.086z",
    opacity: 0.634,
    transform: "rotate(-15 568.883 -999.789)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1C2",
    d: "M58.729 55.665L11.218 47.646 19.237 0.134 66.748 8.153 58.729 55.665",
    transform: "rotate(-15 568.883 -999.789)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#8DC3EB",
    d: "M60.797 62.423L13.983 51.016 25.39 4.202 72.204 15.608 60.797 62.423",
    transform: "rotate(-15 568.883 -999.789)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7E6FD",
    d: "M55.139 64.818L7.627 56.799 15.646 9.287 63.158 17.306 55.139 64.818",
    transform: "rotate(-15 568.883 -999.789)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6D98E",
    d: "M47.512 67.359L0 59.341 8.019 11.829 55.531 19.848 47.512 67.359",
    transform: "rotate(-15 568.883 -999.789)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDC530",
    d: "M55.636 71.137L8.125 63.119 16.145 15.607 63.656 23.626 55.636 71.137",
    transform: "rotate(-15 568.883 -999.789)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1C2",
    d: "M42.528 80.509L5.391 49.809 36.091 12.672 73.228 43.372 42.528 80.509",
    transform: "rotate(-15 568.883 -999.789)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySummary);
export default __webpack_public_path__ + "static/media/empty-summary.6c8dcc500ced3c669f2df3a0ca3f296e.svg";
export { ForwardRef as ReactComponent };